import axios from "axios";
import { dynamicConfig } from "../../config";
import { AuthorizationTokens } from "../../types";

import { serverPath } from "./config";
import { getTokens, setTokenForRefresh } from "./helpers/authorization";

const baseUrl = dynamicConfig.serverUrl;

const instance = axios.create({
  headers: {
    "Content-Type": "application/json; charset=utf-8",
  },
  baseURL: baseUrl,
});

export async function postRefreshToken() {
  const { refreshToken } = getTokens();
  if (refreshToken) {
    setTokenForRefresh();
  } else {
    return Promise.reject(new Error("No refresh token"));
  }

  return instance.post<AuthorizationTokens>(serverPath.refresh, { refreshToken });
}

export default instance;
